<template>
  <div>
    <canvas ref="qrCanvas"></canvas>
  </div>
</template>

<script>
import QRCode from "qrcode";

export default {
  props: {
    ticketId: {
      type: String,
      required: true,
    },
    showBookingID: {
      type: Boolean,
      required: true,
    },
  },
  mounted() {
    this.generateQRCode();
  },
  methods: {
    async generateQRCode() {
      const canvas = this.$refs.qrCanvas;
      const ctx = canvas.getContext("2d");
      const busId = this.ticketId;

      let ticketURL;

      if (this.showBookingID) {
        ticketURL = busId;
      } else {
        const deepLinkValue = busId ? encodeURIComponent(busId) : "";
        // ticketURL = `https://routebus.onelink.me/eOM6/5x0g5ino?deep_link_value=${deepLinkValue}`;
        ticketURL = `https://routebus.in/redirect/${ deepLinkValue }`;
      }

      // Your requested size
      canvas.width = 350;
      canvas.height = 350;

      ctx.fillStyle = "white";
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      const qrCanvas = document.createElement("canvas");

      await QRCode.toCanvas(qrCanvas, ticketURL, {
        errorCorrectionLevel: "H",
        width: 340,
        margin: 4,
        color: {
          dark: "#000000",
          light: "#FFFFFF",
        },
      });

      const qrX = (canvas.width - qrCanvas.width) / 2;
      const qrY = 0;

      ctx.drawImage(qrCanvas, qrX, qrY);

      const logo = new Image();
      logo.src = "/images/mainLogo.jpg";

      logo.onload = () => {
        const logoSize = 50;

        const padding = {
          top: 10,
          right: 10,
          bottom: 10,
          left: 10,
        };

        const qrCenterX = qrX + qrCanvas.width / 2;
        const qrCenterY = qrY + qrCanvas.width / 2;

        const x = qrCenterX - logoSize / 2;
        const y = qrCenterY - logoSize / 2;

        ctx.fillStyle = "white";
        ctx.fillRect(
          x - padding.left,
          y - padding.top,
          logoSize + padding.left + padding.right,
          logoSize + padding.top + padding.bottom
        );
        ctx.drawImage(logo, x, y, logoSize, logoSize);
      };
    },
    downloadQRCode() {
      const canvas = this.$refs.qrCanvas;
      const link = document.createElement("a");
      link.download = `qr-${this.ticketId}.png`;
      link.href = canvas.toDataURL("image/png");
      link.click();
    },
  },
};
</script>
